
import { defineComponent, watch } from "vue";
import router from "@/router";
import store from "@/store";
import { ISystemTemplatesModel } from "@/interfaces/modules";
import SystemTemplatesService from "@/api/Template/TemplatesService";

export default defineComponent({
  name: "SystemTemplateForm",
  data() {
    return {
      templateId: this.$route.params.id || 0,
      form: {
        record: {} as ISystemTemplatesModel,
      },
      variables: [] as string[],
    };
  },
  async mounted() {
    if (parseInt(this.templateId as any) > 0) {
      const record = await SystemTemplatesService.GetTemplatesById({
        Id: this.templateId,
      } as any);
      Object.assign(this.form.record, record);
      this.extractVariables(record.HtmlContent);
    }
    this.setupWatcher();
  },
  methods: {
    cancel() {
      router.push({ name: "Templates" });
    },

    async handleSubmit() {
      try {
        console.log("Submitting form with record:", this.form.record);
        const res = await SystemTemplatesService.PostTemplates(this.form.record);
        store.dispatch("core/popupDialog", {
          text: "Plantilla guardada exitosamente.",
          type: "success",
        });
        this.cancel();
      } catch (err) {
        store.dispatch("core/popupDialog", {
          text: `Error al guardar: ${err}`,
          type: "error",
        });
      }
    },

    extractVariables(html: string) {
      const regex = /{{\s*([^}]+)\s*}}/g;
      const matches = [...html.matchAll(regex)].map((m) => m[1].trim());
      this.variables = [...new Set(matches)];
    },

    setupWatcher() {
      watch(
        () => this.form.record.HtmlContent,
        (newVal) => {
          this.extractVariables(newVal || "");
        }
      );
    },
  },
});
